import React, { useState } from "react";
import useLanguage from "../../hooks/useLanguage";
import { PopUp } from "./Popup";

const CopyButton = ({ textToCopy, className = "" }) => {
  const { language } = useLanguage();
  const [copied, setCopied] = useState(false);
  const [popup, setPop] = React.useState(null);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      setPop({ title: language.COPIED, type: "success" });
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("error:", err);
    }
  };

  return (
    <>
      {popup != null && (
        <PopUp
          unmount={() => setPop(null)}
          title={popup.title}
          type={popup.type}
        />
      )}
      <button
        onClick={handleCopy}
        className={`inline-flex items-center justify-center  rounded-md  transition-colors ${className}`}
        title={copied ? language.COPIED : language.COPY_TO_CLIPBOARD}
      >
        {copied ? (
          <svg
            stroke="currentColor"
            fill="currentColor"
            strokeWidth="0"
            className="w-4 h-4"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="m10 15.586-3.293-3.293-1.414 1.414L10 18.414l9.707-9.707-1.414-1.414z"></path>
          </svg>
        ) : (
          <svg
            stroke="currentColor"
            fill="currentColor"
            strokeWidth="0"
            viewBox="0 0 256 256"
            className="w-4 h-4"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M216,32H88a8,8,0,0,0-8,8V80H40a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H168a8,8,0,0,0,8-8V176h40a8,8,0,0,0,8-8V40A8,8,0,0,0,216,32ZM160,208H48V96H160Zm48-48H176V88a8,8,0,0,0-8-8H96V48H208Z" />
          </svg>
        )}
      </button>
    </>
  );
};

export default CopyButton;
